module.exports = __webpack_public_path__ + "img/BreakfastAtGranddad.41ead1f9.jpg";